import React from 'react';
import { cn } from '../../utils/cn';

export function Input({ className, type, ...props }) {
    return (
        <input
            type={type}
            className={cn(
                'flex h-9 w-full rounded-md border border-slate-200 bg-white px-3 py-1 text-sm shadow-sm transition-colors outline-none placeholder:text-slate-400',
                'focus-visible:border-primary-500 focus-visible:ring-primary-200 focus-visible:ring-2',
                'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
                className
            )}
            {...props}
        />
    );
}
